import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { IntegrationComponent } from './integration.component';
import { ApiKeyComponent } from './api-key/api-key.component';
import { ReferrerComponent } from './referrer/referrer.component';
import { WebhookComponent } from './webhook/webhook.component';
import { WebhookDetailComponent } from './webhook/webhook-detail/webhook-detail.component';

const routes: Routes = [
  { path: '', component: IntegrationComponent },
  { path: 'api-key', component: ApiKeyComponent },
  { path: 'referrer', component: ReferrerComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class IntegrationRoutingModule { }
